export enum TripPatternPlottedOrientation {
    OUTBOUND = 1,
    INBOUND = 2,
    CIRCULAR = 3
}